import Config from '@/config'
import Cookies from 'js-cookie'
import wx from 'weixin-js-sdk'

export const setToken = token => {
  Cookies.set(Config.token_key, token, { expires: 1 })
}

export const getToken = () => {
  const token = Cookies.get(Config.token_key)
  if (token) return token
  else return false
}

export const getNowFormatDate = () => {
  let date = new Date()
  let seperator1 = ''
  let seperator2 = ''
  let month = date.getMonth() + 1
  let strDate = date.getDate()
  if (month >= 1 && month <= 9) month = '0' + month
  if (strDate >= 0 && strDate <= 9) strDate = '0' + strDate
  let currentdate =
    date.getFullYear() +
    seperator1 +
    month +
    seperator1 +
    strDate +
    date.getHours() +
    seperator2 +
    date.getMinutes() +
    seperator2 +
    date.getSeconds()
  return currentdate
}
export const funcUrlDel = (name) => {
  var loca = window.location
  var baseUrl = loca.origin + loca.pathname + '?'
  var query = loca.search.substr(1)
  if (query.indexOf(name) > -1) {
    var obj = {}
    var arr = query.split('&')
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split('=')
      obj[arr[i][0]] = arr[i][1]
    };
    delete obj[name]
    var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g, '').replace(/\:/g, '=').replace(/\,/g, '&')
    return url
  } else {
    return window.location.href
  }
}
export const getNowtDate = () => {
  var date = new Date()
  var seperator1 = '-'
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate
  return currentdate
}
export const getRequest = () => {
  // 获取url参数
  let url = window.location.search
  let theRequest = {}
  if (url.indexOf('?') !== -1) {
    let str = url.substr(1)
    let strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return theRequest
}
// 全局判断是否IOS方法
export const isIos = () => {
  const u = navigator.userAgent
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}

// 微信分享
export const wxShare = (title, link, imgUrl) => {
  wx.ready(() => {
    // 分享朋友圈
    wx.onMenuShareTimeline({
      title: title,
      link: link,
      imgUrl: imgUrl
    })
    // 分享给好友
    wx.onMenuShareAppMessage({
      title: title, // 分享标题
      // desc: '这是一个自定义的描述！', // 分享描述
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 自定义图标
      type: 'link', // 分享类型,music、video或link，不填默认为link
      dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
    })
  })
}

// 阿拉伯数字转汉字
export const numToWord = (number) => {
  let result = []
  const word = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const unit = ['', '十', '百']

  const temp = number
    .toString()
    .split('')
    .reverse()
  for (let i = 0; i < temp.length; i++) {
    result.push(unit[i])
    if (i === 0) {
      if (parseInt(temp[i]) !== 0) {
        // 空
        result.push(word[temp[i]])
      }
    } else if (i === 1) {
      if (parseInt(temp[i]) > 1) {
        // 空
        result.push(word[temp[i]])
      }
    } else {
      result.push(word[temp[i]])
    }
  }

  return result.reverse().join('')
}
// 判断当前时间是否在d1和d2之间
export const nowInDateBetwen = (d1, d2) => {
  let dateBegin = new Date(d1.replace(/-/g, '/')) // 将-转化为/，使用new Date
  let dateEnd = new Date(d2.replace(/-/g, '/')) // 将-转化为/，使用new Date
  let dateNow = new Date() // 获取当前时间

  let beginDiff = dateNow.getTime() - dateBegin.getTime() // 时间差的毫秒数
  let beginDayDiff = Math.floor(beginDiff / (24 * 3600 * 1000)) // 计算出相差天数

  let endDiff = dateEnd.getTime() - dateNow.getTime() // 时间差的毫秒数
  let endDayDiff = Math.floor(endDiff / (24 * 3600 * 1000)) // 计算出相差天数
  if (endDayDiff < 0) {
    // 已过期
    return -1
  }
  if (beginDayDiff < 0) {
    // 没到开始时间
    return 0
  }
  return 1
}
